<script lang="ts" setup>
import { computed } from 'vue'
import { translate } from '@/i18n/i18n.ts'
import { usePriceDisplayState } from '@/composables/state/price-display-state.composable.ts'
import { formatPrice } from '@/utils/price.util.ts'

import type { PriceDisplayProps } from '@/components/atom/price-display/PriceDisplay.vue'

import { LIconButton } from '@wgg.hyve/hyve-ui-library'

type TextStyle = 'regular' | 'bold'
type TextAlign = 'start' | 'end'

export type LabelProps = {
  prefixLabel?: string
  prefixStyle?: TextStyle

  suffixLabel?: string
  suffixPosition?: TextAlign
  showInfoIcon?: boolean
}

type PriceLabelProps = Partial<PriceDisplayProps> & LabelProps

const props = withDefaults(defineProps<PriceLabelProps>(), {
  prefixLabel: translate('product.payment_prefix_from'),
  prefixStyle: 'regular',
  suffixPosition: 'start',
  showInfoIcon: true
})

const emit = defineEmits<{
  openPriceTableModal: []
}>()

const state = usePriceDisplayState(props)
const { showPriceNumber } = state

const suffixStyles = computed(() => {
  return {
    'price-display__label--end': props.suffixPosition === 'end'
  }
})
</script>

<template>
  <div class="price-display">
    <div class="price-display__text-wrapper">
      <div class="price-display__price">
        <span v-if="showPriceNumber">{{ formatPrice(props.price!) }}</span>
        <span v-else><span class="price-display__invalid"></span> €</span>
      </div>
      <LIconButton
        v-if="props.showInfoIcon"
        icon="lnx-info"
        :aria-label="translate('form_fields.a11y.purchase_price_info')"
        size="xl"
        class="product-offer-card__details-button"
        @click="emit('openPriceTableModal')"
      />
    </div>
    <div v-if="!!suffixLabel" :class="suffixStyles" class="price-display__label">
      {{ suffixLabel }}
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import 'price-display-label';
</style>
